import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';
import { useSidebar } from '../../context/SidebarContext';
import { StyledButton } from '../StyledButton';
import { StatusModalConfirmClick } from '../StyledModalConfirmClick';
import SidebarData, { ISidebar } from './SidebarData';
import { AsideButton } from './components/AsideButton';
import { ButtonHideSidebar, Container, LinkHome } from './styles';
import { useUser } from '../../context/UserContext';

export const AsideMenu = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [active, setActive] = useState<number | undefined>(undefined);
  const { sidebar, setSidebar } = useSidebar();
  const { logout } = useUser();

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    SidebarData.forEach((data: ISidebar) => {
      if (`/${data.path}` === pathname) {
        setActive(data.id);
      }
    });
  }, [pathname]);

  const handleToNavigateTOLogin = () => {
    navigate('/login');
  };

  const handleToLogout = () => {
    setShowModal(true);
  };

  return (
    <Container showSidebar={sidebar}>
      <ButtonHideSidebar
        showSidebar={sidebar}
        onClick={() => setSidebar(!sidebar)}
        type="button"
      >
        {sidebar ? <AiOutlineArrowLeft /> : <AiOutlineArrowRight />}
      </ButtonHideSidebar>

      <LinkHome
        onClick={() => {
          setActive(undefined);
          navigate('/');
        }}
      >
        <img alt="" src="/logos/zignet-logo-text.png" />
      </LinkHome>

      <ul>
        {SidebarData.map((data: ISidebar, i) =>
          data.path ? (
            <Link to={data.path} key={data.id.toString()}>
              <AsideButton
                title={data.title}
                icon={data.icon}
                key={i}
                submenu={data.submenu}
                active={active === data.id ? 'active' : ''}
                onClick={() => setActive(data.id)}
              />
            </Link>
          ) : (
            <AsideButton
              key={data.id.toString()}
              title={data.title}
              icon={data.icon}
              submenu={data.submenu}
            />
          ),
        )}
      </ul>
      <aside>
        {showModal && (
          <StatusModalConfirmClick
            type="question"
            text="Deseja realmente sair?"
            setModal={setShowModal}
            twoButtons={true}
            callActions={[logout, handleToNavigateTOLogin]}
          />
        )}
        <StyledButton
          className="logout-button"
          iconPosition="right"
          icon={
            <img className="" src="/logos/logout-logo.png" alt="logout logo" />
          }
          backgroundColor="transparent"
          onClick={handleToLogout}
          text={''}
        />
      </aside>
    </Container>
  );
};
